
import * as actionTypes from '../actionTypes'
import * as constants from '../Constatnts'
import axios from 'axios';


export function getCoupons() {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/crm/coupon`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return  response.data.Coupons;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function saveCoupon(coupon, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key) {
        // Update existing coupon
        response = await axios.put(
          `${constants.API_URL}/crm/coupon/${key}`,
          coupon,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new coupon
        response = await axios.post(
          `${constants.API_URL}/crm/coupon`,
          coupon,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

        if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function deleteCoupon(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/crm/coupan/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return  true;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




export function getApplicableCoupons(registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      // Call API instead of Firebase
      const response = await axios.get(
        `${constants.API_URL}/crm/coupon`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const coupons = response.data.Coupons.filter(
        (item) => item.IsDeleted === false
      );

      let applicableCoupons = [];

      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      const today = new Date().setHours(0, 0, 0, 0);

      if (coupons.length > 0) {
        for (let i = 0; i < coupons.length; i++) {
          const coupon = coupons[i];

          const validityFrom = new Date(coupon.ValidityFrom).setHours(
            0,
            0,
            0,
            0
          );

          const validityTo = new Date(coupon.ValidityTo).setHours(
            0,
            0,
            0,
            0
          );

          const isValidDate =
            validityFrom <= today && today <= validityTo;

          const isSpecificDay =
            coupon.SpecificDay &&
            coupon.SpecificDay.toLowerCase() === "yes";

          const isValidDay = isSpecificDay
            ? coupon.SpecificDays.includes(days[new Date().getDay()])
            : true;

          // All Stores
          if (coupon.AllStores) {
            if (isValidDate && isValidDay) {
              applicableCoupons.push(coupon);
            }
          } else {
            // Specific Stores
            for (let j = 0; j < coupon.Stores.length; j++) {
              const store = coupon.Stores[j];

              if (
                store.value === getState().user.store.key &&
                isValidDate &&
                isValidDay
              ) {
                applicableCoupons.push(coupon);
                break;
              }
            }
          }
        }
      }

      console.log(applicableCoupons);

      return applicableCoupons;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

